module.exports = __webpack_public_path__ + "img/tv.da001f2c.svg";